/*
 * @Author: zhangsheng
 * @Date: 2023-09-18 13:19:34
 * @LastEditors: duyuanyuan
 * @LastEditTime: 2023-09-28 14:37:19
 * @FilePath: \panda-index-sicermem-frontend\src\locales\zh-CN\aboutUs.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
export default {
  'Componey.index.172950-0': '国家发明奖',
  'Componey.index.172950-1': '项',
  'Componey.index.172950-2': '国家科技进步奖',
  'Componey.index.172950-3': '省部级科技进步奖',
  'Componey.index.172950-4': '省重大节能成果奖',
  'Componey.index.172950-5': '主要荣誉',
  'Componey.index.172950-6': '技术专家和研发团队',
  'Componey.index.172950-7': '公司质量方针',
  'Componey.index.172950-8': '精益求精、持续改进、品质卓越、满足顾客',
  'Componey.index.172950-9':
    '公司始终以满足客户需求为第一标准，用高标准建立与完善产品质量体系，于2003年通过中国质量认证中心（CQC）的ISO9001质量体系认证，2012年通过ISO9001：2008标准体系认证。',

  'Purpose.index.534003-0': '高性能陶瓷膜的制造商',
  'Purpose.index.534003-1': '合适陶瓷膜的生产厂',
  'Purpose.index.534003-2': '膜行业可信赖的伙伴',
  'Purpose.index.534003-3': '企业宗旨',

  'Qualifications.index.609371-4': '企业资质',

  'TestCenter.index.690467-0': '硅苑检测中心',
  'TestCenter.index.690467-1':
    '开展对陶瓷材料的化学成分分析、微观结构分析、物理性能测试等的检验检测技术服务，为公司的无机非金属行业的研究开发、产品质量控制、标准化生产管理等方面提供专业数据检测、采集、分析服务。',

  'AboutUs.index.745708-0': '享受国务院特殊津贴',
  'AboutUs.index.745708-1': '人次',
  'AboutUs.index.745708-2': '国家级有突出贡献的中青年专家',
  'AboutUs.index.745708-3': '人',
  'AboutUs.index.745708-4': '省、市（厅）级技术拔尖人才',
  'AboutUs.index.745708-5': '硅元膜SICERMEM',
  'AboutUs.index.745708-6':
    '上海硅苑膜科技有限公司源于1958年成立的山东省硅酸盐研究设计院，于2020年被上海市科委认定为国家级高新技术企业。',
  'AboutUs.index.745708-7':
    '经过60多年的积淀，已发展成集W无机膜、常规平板陶瓷膜为一体，在国内外领先水平的无机膜材料研究、开发和生产基地。',
  'AboutUs.index.745708-8':
    '上海硅苑膜通过与丹麦奥尔堡大学、同济大学等国内外著名高校、研究机构、以及大型水务集团的合作，全面提升了陶瓷膜的核心技术，实现了可持续发展，可为合作伙伴提供定制化的无机膜产品。',
  'AboutUs.index.745708-9': '技术专家和研发团队',
  'AboutUs.index.745708-10': 'aboutus',
  'AboutUs.index.745708-11': '/aboutus/introduce',
  'AboutUs.index.745708-12': '/aboutus/componey',
  'AboutUs.index.745708-13': '/aboutus/testCenter',
  'AboutUs.index.745708-14': '/aboutus/purpose',
  'AboutUs.index.745708-15': '/aboutus/qualifications',

  'AboutUs.Tab1': '犬舍介绍'
};
